export default __webpack_public_path__ + "static/media/header.ffcc981f.jpg";